import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ASSETS, CONTACT } from "../lib/brand";
import Hero from "../components/Hero";

const CARDS = [
  {
    to: "/proposito",
    label: "Propósito",
    caption: "Três atos que guiam minha moda circular",
    img: ASSETS.hangers,
    n: "01",
  },
  {
    to: "/sobre",
    label: "Sobre a Herida",
    caption: "Uma mulher, um propósito — a curadora por trás",
    img: ASSETS.hero,
    n: "02",
  },
  {
    to: "/servicos",
    label: "Serviços",
    caption: "Curadoria, consultoria e Live Shop",
    img: ASSETS.rack,
    n: "03",
  },
  {
    to: "/produtos",
    label: "Produtos",
    caption: "Femininos · Masculinos · Infantis · Decor",
    img: "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1200&auto=format&fit=crop&q=80",
    n: "04",
  },
  {
    to: "/loja",
    label: "Loja & Editorial",
    caption: "Tour em vídeo + recorte visual do universo",
    img: ASSETS.phone,
    n: "05",
  },
  {
    to: "/depoimentos",
    label: "Depoimentos",
    caption: "Feedback real + avaliações Google",
    img: ASSETS.reviews,
    n: "06",
  },
];

function NavCard({ card, i }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.8, delay: 0.05 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={card.to}
        data-testid={`home-card-${card.to.replace("/", "")}`}
        className="group relative flex flex-col overflow-hidden bg-cream border border-ink-800/15 hover:border-brick-500 transition-colors duration-500"
      >
        <div className="relative aspect-[4/5] overflow-hidden bg-cream-200">
          <img
            src={card.img}
            alt={card.label}
            loading="lazy"
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
          />
          <div
            aria-hidden
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(26,24,24,0) 40%, rgba(26,24,24,0.55) 100%)",
            }}
          />
          <div className="absolute top-3 left-3 right-3 flex justify-between font-mono text-[9px] uppercase tracking-[0.3em] text-cream">
            <span>{card.n}</span>
            <span>→</span>
          </div>
          <div className="absolute left-4 right-4 bottom-4">
            <span
              className="font-serif italic text-cream leading-none"
              style={{ fontSize: "clamp(1.5rem, 2vw, 2rem)" }}
            >
              {card.label}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-between gap-4 px-5 py-5 border-t border-ink-800/10">
          <p className="font-sans text-sm leading-relaxed text-ink-800/75 max-w-xs">
            {card.caption}
          </p>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-brick-500 whitespace-nowrap group-hover:translate-x-1 transition-transform duration-500">
            Abrir →
          </span>
        </div>
      </Link>
    </motion.div>
  );
}

export default function Home() {
  return (
    <>
      <Hero />

      {/* Navigation card grid */}
      <section
        data-testid="home-cards"
        className="relative bg-cream-100 py-24 sm:py-40 border-t border-ink-800/15"
      >
        <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
          <div className="grid grid-cols-12 gap-6 lg:gap-16 items-end mb-16">
            <div className="col-span-12 lg:col-span-7">
              <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-800/60 mb-8">
                <span className="w-8 h-px bg-brick-500" />
                <span>Índice — 06 capítulos</span>
              </div>
              <h2
                className="font-serif leading-[0.9] tracking-tight text-ink-800"
                style={{ fontSize: "clamp(2.5rem, 6vw, 6rem)" }}
              >
                Por onde <br />
                <span className="italic-serif text-brick-500">prefere começar</span>?
              </h2>
            </div>
            <div className="col-span-12 lg:col-span-4 lg:col-start-9">
              <p className="font-sans text-base sm:text-lg leading-relaxed text-ink-800/70">
                Cada capítulo abre uma porta do universo desapegue.
                Toque no que te chamar mais atenção.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {CARDS.map((c, i) => (
              <NavCard key={c.to} card={c} i={i} />
            ))}
          </div>

          {/* Final CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-16 sm:mt-24 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 border-t border-ink-800/15 pt-10"
          >
            <p
              className="font-serif italic text-ink-800 leading-tight max-w-2xl"
              style={{ fontSize: "clamp(1.5rem, 2.4vw, 2.5rem)" }}
            >
              Prefere ir direto ao ponto? <span className="text-brick-500">Fale comigo.</span>
            </p>
            <div className="flex items-center gap-4">
              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid="home-final-whatsapp"
                className="btn-brick"
              >
                Falar no WhatsApp
              </a>
              <Link
                to="/contato"
                data-testid="home-final-contato"
                className="btn-ghost"
              >
                Ver contatos
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
